define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function IllegalContentFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    IllegalContentFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: IllegalContentFail,
        className: 'IllegalContentFail',
        radarName: 'fail_{SOURCE}_illegal-content',
        message: 'Заблокированный контент.',
    });

    module.exports = IllegalContentFail;
});
